<template>
  <v-modal
    :name="name"
    title="Editar perfil"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="3"
    v-else-if="name == 'edit-profile-client'"
  >
    <v-inner>
      <div v-if="edit_profile_client_avatar_select">
        <v-row :size="2">
          <v-col
            :xs="6"
            :sm="3"
            :md="3"
            :lg="2"
            v-for="(n, i) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 0]"
          >
            <v-button
              class="px-0 d-block w-100"
              @click="
                edit_profile_client_avatar_select = false;
                data.client.avatar = 'static/avatars/' + n + '.svg';
              "
            >
              <v-avatar :image="'static/avatars/' + n + '.svg'"></v-avatar>
            </v-button>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-tabs class="mb-3 nav-tabs">
          <v-button href="#tab-profile" class="active">Perfil</v-button>
          <v-button href="#tab-account">Conta</v-button>
          <v-button href="#tab-contract">Contrato PF</v-button>
        </v-tabs>
        <div class="tab-content">
          <v-content
            class="tab-pane active show"
            id="tab-profile"
            role="tabpanel"
          >
            <v-row>
              <v-col :xs="12" :sm="12" :md="12" :lg="3">
                <v-avatar
                  class="pointer"
                  @click="edit_profile_client_avatar_select = true"
                  :image="data.client.avatar"
                ></v-avatar>
                <v-button
                  class="block gray size-2 mb-5"
                  @click="edit_profile_client_avatar_select = true"
                  >Trocar</v-button
                >
              </v-col>
              <v-col :xs="12" :sm="12" :md="12" :lg="9">
                <v-row class="size-2">
                  <v-col :xs="12" :sm="12">
                    <v-input
                      type="select"
                      :options="['PJ', 'PF']"
                      class="m-0"
                      v-model="data.client.sign_type"
                      >Assinar contrato como</v-input
                    >
                  </v-col>
                  <v-col :xs="12" :sm="12">
                    <v-text
                      >As informações abaixo serão apresentadas aos
                      profissionais que você contratar.</v-text
                    >
                  </v-col>
                  <v-col :xs="12" :sm="4">
                    <v-input
                      type="tel"
                      class="m-0"
                      v-model="data.client.cel_phone"
                      >Celular</v-input
                    >
                  </v-col>
                  <v-col :xs="12" :sm="4">
                    <v-input
                      type="text"
                      class="m-0"
                      placeholder="username"
                      v-model="data.client.skype"
                      >Skype</v-input
                    >
                  </v-col>
                  <v-col :xs="12" :sm="4">
                    <v-input
                      type="text"
                      class="m-0"
                      placeholder="username"
                      v-model="data.client.hangout"
                      >Hangout</v-input
                    >
                  </v-col>
                  <v-col :xs="12" :sm="12">
                    <v-input
                      type="text"
                      class="m-0"
                      placeholder="http://"
                      v-model="data.client.linkedin"
                      >URL do perfil do LinkedIn</v-input
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-content>
          <v-content class="tab-pane" id="tab-account" role="tabpanel">
            <v-row class="size-2">
              <v-col :xs="12" :sm="5">
                <v-input type="text" class="m-0" v-model="data.client.name"
                  >Nome</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="7">
                <v-input type="text" class="m-0" v-model="data.client.lastname"
                  >Sobrenome</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="12">
                <v-input type="text" class="m-0" v-model="data.client.email"
                  >Email</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="10">
                <v-input type="text" class="m-0" v-model="currentBillingEmail"
                  >Email de NF</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="2">
                <v-button
                  class="primary mt-4"
                  :disabled="!currentBillingEmail"
                  @click="addBillingEmailsChip(currentBillingEmail)"
                  >Adicionar</v-button
                >
              </v-col>
              <v-col :xs="12" :sm="12">
                <v-chip
                  :chips="data.client.billing_emails"
                  label="Seus emails"
                  :onRemoveChip="removeBillingEmailsChip"
                  multiple
                />
              </v-col>
              <v-col :xs="12" :sm="12">
                <v-input
                  type="textarea"
                  class="m-0"
                  v-model="data.client.billing_observation"
                  >Observação</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="6">
                <v-input
                  type="password"
                  v-model="data.client.password"
                  class="m-0"
                  helptext="Preencher somente se desejar trocar a senha atual."
                  placeholder="******"
                  >Senha</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="6">
                <v-input
                  type="repassword"
                  :repassword="data.client.password"
                  v-model="data.client.password_confirmation"
                  class="m-0"
                  placeholder="******"
                  >Repetir senha</v-input
                >
              </v-col>
            </v-row>
          </v-content>
          <v-content class="tab-pane" id="tab-contract" role="tabpanel">
            <p>
              Informações necessárias para assinar contratos como pessoa física.
            </p>
            <v-row class="size-2">
              <v-col :xs="12" :sm="5">
                <v-input
                  type="cpf"
                  class="m-0"
                  v-model="data.client.cpf"
                  v-bind:class="isRequiredPF(data.client.cpf)"
                  >CPF</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="8">
                <v-input
                  type="text"
                  class="m-0"
                  v-model="data.client.address"
                  v-bind:class="isRequiredPF(data.client.address)"
                  >Rua</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="4">
                <v-input
                  type="text"
                  class="m-0"
                  v-model="data.client.address_number"
                  v-bind:class="isRequiredPF(data.client.address_number)"
                  >Número</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="4">
                <v-input
                  type="text"
                  class="m-0"
                  v-model="data.client.address_compl"
                  >Complemento</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="5">
                <v-input
                  type="text"
                  class="m-0"
                  v-model="data.client.address_district"
                  v-bind:class="isRequiredPF(data.client.address_district)"
                  >Bairro</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="3">
                <v-input
                  type="zipcode"
                  class="m-0"
                  v-model="data.client.address_zipcode"
                  v-bind:class="isRequiredPF(data.client.address_zipcode)"
                  >CEP</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="8">
                <p>
                  Cidade e UF são usados tanto para contratos quando para o seu
                  perfil.
                </p>
              </v-col>
              <v-col :xs="12" :sm="8">
                <v-input
                  type="text"
                  class="m-0"
                  v-model="data.client.city"
                  v-bind:class="isRequiredPF(data.client.city)"
                  >Cidade</v-input
                >
              </v-col>
              <v-col :xs="12" :sm="4">
                <v-input
                  type="select"
                  :options="$app.data.uf"
                  v-model="data.client.state"
                  v-bind:class="isRequiredPF(data.client.state)"
                  class="m-0"
                  >UF</v-input
                >
              </v-col>
            </v-row>
          </v-content>
        </div>
        <div class="text-right">
          <v-divider line />
          <v-button
            class="primary"
            @click="updateClientProfile()"
            :disabled="ableUpdate"
            >Atualizar</v-button
          >
        </div>
      </div>
    </v-inner>
  </v-modal>
</template>

<script>
import clientApi from '@/api/client';

export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'client',
    },
    data: {},
  },
  data() {
    return {
      billingEmails: [
        'brendamatias.sobral@gmail.com',
        'brendamatias.sobral2@gmail.com',
        'brendamatias.sobral3@gmail.com',
        'brendamatias.sobral4@gmail.com',
      ],
      edit_profile_client_avatar_select: false,
      currentBillingEmail: '',
    };
  },
  computed: {
    ableUpdate() {
      return (
        this.data.client.password !== this.data.client.password_confirmation
      );
    },
  },
  methods: {
    addBillingEmailsChip() {
      if (this.currentBillingEmail === '') return;
      const emailAlreadyExists = this.data.client.billing_emails.includes(
        this.currentBillingEmail
      );

      if (!emailAlreadyExists) {
        this.data.client.billing_emails.push(this.currentBillingEmail);
      }

      this.currentBillingEmail = '';
    },
    removeBillingEmailsChip(item) {
      this.data.client.billing_emails.splice(
        this.data.client.billing_emails.indexOf(item),
        1
      );
      this.data.client.billing_emails = [...this.data.client.billing_emails];
    },
    isRequiredPF(value) {
      if (
        this.data.client.sign_type === 'PF' &&
        (value === 'undefined' || value === '')
      ) {
        return 'is-invalid';
      } else {
        return '';
      }
    },
    hide() {
      this.onHide();
      this.show = false;
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');

      // OK vars
      this.feedback_ok = false;
      this.bug_ok = false;
      this.money_transfer_ok = false;
      this.help_ok = false;
      this.finalized_ok = false;
      //
      clientApi
        .getClientData()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientProfileData', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    updateClientProfile() {
      // this.data.client.client_companies = []
      clientApi
        .updateProfile(this.data.client)
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientProfileData', response.data);
            this.$store.dispatch('updateName', response.data.name);
            this.hide();
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/client-profile-edit.vue